// extracted by mini-css-extract-plugin
module.exports = {"name":"groupList_name__1u1vM","icon":"groupList_icon__3_qO7","rooms":"groupList_rooms__W6ORq","more":"groupList_more__3ygjf"};